module.exports = __webpack_public_path__ + "static/media/brown20.50f3fc07.png";